export const formatCount = (value: number): string => value.toLocaleString();

export const formatCountOr = (
  value: number | null | undefined,
  fallback: string = "0",
): string => {
  if (value === null || value === undefined) {
    return fallback;
  }

  return formatCount(value);
};
